<script>
export default {
  functional: true,
  props: {
    level: Number|String,
  },
  render: function(h, context) {
    const baseClass = 'subheading';
    const tag = context.props.level ? `h${context.props.level}` : `p`;

    context.data.class = [
      baseClass,
      context.data.class
    ].join(' ');

    return h(tag, context.data, context.children);
  }
}
</script>
